import React, { useEffect } from 'react'
import { compose } from 'recompose'
import { connect, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl'
import { Button, Typography } from '@material-ui/core'
import { fetchCurrentBackendVersion, setVersionMismatchAlertVisibility } from '../redux/actions'
import { currentBackendVersionSelector, isVersionMismatchAlertVisibleSelector } from '../redux/selectors'
import { useTheme, withStyles } from '@material-ui/core'

const styles = (theme) => ({

	alertMessageOuter: {
        position: 'fixed',
        zIndex: '1111',
        top: '0',
        left: 0,
        right: 0,
        height: '84px', 
        fontSize: '24px',
        backgroundImage: 'linear-gradient(to bottom, #072243, #030f20)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        width: '100%',
        overflow: 'auto',
        "& + main .mainPatientWrapper": {
            maxHeight: 'calc(100vh - 168px)',
            minHeight: 'calc(100vh - 168px)', 
            [theme.breakpoints.down('sm')]: {
                maxHeight: 'calc(100vh - 199px)',
                minHeight: 'calc(100vh - 199px)',
            },            
        },
        "& + main .mainPatientWrapper": {
            paddingTop: '168px',
            minHeight: 'calc(100vh - 168px)',
            [theme.breakpoints.down('sm')]: {
                paddingTop: '199px',
                minHeight: 'calc(100vh - 199px)',
            },
        },

        "& + main .mainHeaderOuter": {
            top: '84px',
            [theme.breakpoints.down('sm')]: {
                top: '137px',
            },
        },
        "& + main .mainHeaderInner": {
            top: '84px',
            
            [theme.breakpoints.down('sm')]: {
                top: '137px',
            },
        },
        "& + main .mainHeaderMenuMobile.navOpened": {
            top: '137px',
        },
        
        [theme.breakpoints.down('sm')]: {            
            height: '137px',
            justifyContent: 'center',
            "& *": {
                fontSize: '12px',
                textAlign: 'center'
            }
        },

    },
    alerMessageInner: {
        maxWidth: '1400px',
        width: '100%',
        justifyContent: 'space-between',
        padding: '5px 39px 5px 25px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'auto',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            justifyContent: 'center',
        }
    },
    reloadButton: {
        marginRight: '0',
        [theme.breakpoints.down('sm')]: {
            padding: '5px 10px',
            fontSize: '14px',
            height: 'auto',
        }
    }
})

const AppUpdatesChecker = ({ intl, children, loadCurrentBackendVersion, currentBackendVersion, showVersionMismatchAlert, hideVersionMismatchAlert, isVersionMismatchAlertVisible, classes }) => {
    const dispatch = useDispatch()

    useEffect(
        () => {

            const f = () => dispatch(function () {
                loadCurrentBackendVersion();
            });

            f();

            let timer = setInterval(f, 5 * 60 * 1000)

            return () => {
                clearInterval(timer)
            }
        }
        , []

    )

    useEffect(
        () => {
            if (currentBackendVersion && process.env.REACT_APP_EXECUTION_ID && currentBackendVersion !== process.env.REACT_APP_EXECUTION_ID) {
                showVersionMismatchAlert();
            } else {
                hideVersionMismatchAlert();
            }
        }
        , [currentBackendVersion]
    )

    return [
        (isVersionMismatchAlertVisible &&
        <div data-print="none" className={classes.alertMessageOuter}>
            <div data-print="none" className={classes.alerMessageInner}>
                <div>
                    <Typography variant='body1'>
                        {intl.formatMessage({ id: 'app.versionMismatchAlert.text' })}
                    </Typography>
                </div>
                <div>
                    <Button className={classes.reloadButton}
                        type='button'
                        variant='contained'
                        color='primary'
                        onClick={() => { window.location.reload() }}
                    >
                        {intl.formatMessage({ id: 'app.versionMismatchAlert.action' })}
                    </Button>
                </div>
            </div>
        </div>
            ),
        children,
        (window.navigator.userAgent.includes('BenchmarcApp') && !window.location.href.startsWith("https://patient.incytesapp.co") &&
            <div data-print="none">
                <div>
                    <Typography variant='body1'>
                        {window.location.origin}
                    </Typography>
                </div>
            </div>
        ),
        (window.navigator.userAgent.toLowerCase().includes('mobile') && !window.location.href.startsWith("https://patient.incytesapp.co") &&
            <div data-print="none">
                <div>
                    <Typography variant='body1'>
                        {window.navigator.userAgent}
                    </Typography>
                </div>
            </div>
        )
    ];
}

const mapStateToProps = (state) => ({
    currentBackendVersion: currentBackendVersionSelector(state),
    isVersionMismatchAlertVisible: isVersionMismatchAlertVisibleSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    loadCurrentBackendVersion: () => dispatch(fetchCurrentBackendVersion()),
    showVersionMismatchAlert: () => dispatch(setVersionMismatchAlertVisibility(true)),
    hideVersionMismatchAlert: () => dispatch(setVersionMismatchAlertVisibility(false))
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl, withStyles(styles))

export default enhance(AppUpdatesChecker)
